import React from 'react'
import styled from 'styled-components'
import Spacer from '../../lib/spacer'
import StoreLinks from '../../common/store_links'
import Timeline from './timeline'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div`
    background-color: ${(props) => props.theme.palette.greyScale.lightestGrey};
    border-top: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
    border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
`

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.testimonials' })

    return (
        <Wrapper>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="main grid-container">
                <div className="grid-x large-text-left large-align-justify small-align-center medium-align-center small-text-center medium-text-center">
                    <div className="cell medium-12 large-6">
                        <h2 className="h1">
                            {t('titleLine1')} <br />
                            {t('titleLine2')}
                        </h2>
                        <p className="lead" style={{ fontSize: '0.75rem', opacity: 0.45 }}>
                            {t('disclaimer')}
                            {t('translatedNote') && <> {t('translatedNote')}</>}
                        </p>
                    </div>
                    <div className="cell shrink hide-for-small-only">
                        <Spacer size={50} className="show-for-medium-only" />
                        <StoreLinks />
                    </div>
                </div>
            </div>
            <Timeline />
            <Spacer size={100} className="show-for-large" />
            <Spacer size={50} className="show-for-medium-only" />
            <Spacer size={20} className="show-for-small-only" />
        </Wrapper>
    )
}
